import { UnitOutput } from 'services/device/domain/business/common/Output';
import { LabelRenderer } from 'services/device/presentation/ui/widget/label-renderer/LabelRenderer';
import { UnitOutputValueRenderer } from 'services/device/presentation/ui/widget/output-value-renderer/UnitOutputValueRenderer';

export interface UnitOutputProps {
	output: UnitOutput;
}

export const UnitOutputRenderer = (props: UnitOutputProps): JSX.Element => {
	const { output } = props;

	return (
		<li key={output.getName()}>
			<strong>
				<LabelRenderer output={output} />
			</strong>
			<p>
				<UnitOutputValueRenderer output={output} />
			</p>
		</li>
	);

};
